import { BASE_URL_LEGACY } from "./";

export const appliancesService = {
  getDetail,
};

function getDetail(user, viewType) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/common/appliances/?user_id=${user}&view_type=${viewType}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}
